import {
  ApiAppNamespaces,
  ApiBackofficeNamespaces,
  IQueuedRequest,
  OneAPIOptions
} from '../../common'
import { AppGoodsIssuedNotesApi } from './app'
import { BackofficeGoodsIssuedNotesApi } from './backoffice'
import { Queue } from '../../queue'

export class GoodsIssuedNotesApp implements ApiAppNamespaces {
  app: AppGoodsIssuedNotesApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppGoodsIssuedNotesApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
  }
}

export class GoodsIssuedNotesBackoffice implements ApiBackofficeNamespaces {
  backoffice: BackofficeGoodsIssuedNotesApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.backoffice = new BackofficeGoodsIssuedNotesApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.backoffice.invalidateAll()
  }
}
